export default {
    locales: [{ 
        "name": "fr", 
        "options": {
            "toolbar": {
            "exportToSVG": "Télécharger vectoriel", "exportToPNG": "Télécharger Image", "exportToCSV": "Télécharger Excel",
            }
        }
    }],
};